import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function AdminPageHeader({
  title,
  subtitle,
  backTo,
  backLabel = "Back",
  actions,
  testId,
}) {
  const navigate = useNavigate();

  return (
    <div className="mb-6" data-testid={testId}>
      {backTo && (
        <button
          type="button"
          onClick={() => navigate(backTo)}
          className="inline-flex items-center gap-2 min-h-11 text-sm font-['Manrope'] admin-muted hover:text-[var(--admin-fg)] mb-1 lg:mb-3"
        >
          <ArrowLeft className="w-4 h-4" />
          {backLabel}
        </button>
      )}
      <div className="flex flex-col gap-3 lg:flex-row lg:items-start lg:justify-between">
        <div className="min-w-0">
          <h1 className="admin-fg hidden lg:block text-2xl font-['Unbounded'] font-bold">
            {title}
          </h1>
          {subtitle && (
            <p className="admin-faint text-sm font-['Manrope'] lg:mt-1">{subtitle}</p>
          )}
        </div>
        {actions && (
          <div className="flex flex-col sm:flex-row sm:flex-wrap gap-2 w-full lg:w-auto">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
}
